"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getVideoThumbnail;

function getVideoThumbnail(videoSelector) {
  var canvas = document.createElement("canvas"),
      videoElement = document.querySelector(videoSelector);
  canvas.height = videoElement.videoHeight, canvas.width = videoElement.videoWidth, canvas.getContext("2d").drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight);
  var imageUrl = canvas.toDataURL();
  return canvas.remove(), imageUrl;
}